import { Tag, Text } from '@equip.health/ui';
import { TreatmentLevelIdToTagColorMap } from '~/components/common/TreatmentOverviewCard/TreatmentLevelIdToTagColorMap';

type PatientNoteTreatmentAttributeLabelProps = {
  id?: number;
  label?: string;
};

const PatientNoteTreatmentAttributeLabel = ({
  id,
  label,
}: PatientNoteTreatmentAttributeLabelProps) => {
  if (!label) {
    return <Text color="neutral.tertiary">Not set</Text>;
  }
  if (id) {
    return (
      <Tag
        color={TreatmentLevelIdToTagColorMap[id]}
        id={`patient_note_treatment_attribute_tag_${label}`}
        value={label}
      />
    );
  }

  return <Text>{label}</Text>;
};

export default PatientNoteTreatmentAttributeLabel;
